module.exports = __webpack_public_path__ + "assets/images/1f0e68859950682fc00c1c84fb73d378.png";